import React from 'react';
import loader from "./loader";
import { showDCRFormModal, hideDCRFormModal } from "./DCRFormModal";
import Logger from './Logger';
import noty from './Noty';

export default class DCRForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mainHub: props.hub,
            eventID: props.eventID,
            simulationID: props.simulationID,
            token: '',
            iframeURL: '',
            referXML: '',
            title: props.title,
            id: props.id,
            role:props.role,
            isSingleData: props.isSingleData
        }
        this.hideModal = this.hideModal.bind(this);
        this.getReferXMLbyId = this.getReferXMLbyId.bind(this);
    }

    componentDidMount() {
        showDCRFormModal(this.state.title, this.hideModal);
        this.getReferXMLbyId();
    }
  
    hideModal() {
        hideDCRFormModal();
        this.props.hideModal(false);
    }

    onFormSubmit = (xml) => {
        let self = this;
        const {mainHub, eventID, simulationID, role, id, isSingleData} = self.state;

        loader('show');
        mainHub.invoke('executeFormTransactionPublic',
            eventID,
            simulationID,
            xml,
            role,
            id,
            isSingleData
        )
            .then(function () {
                self.hideModal();
                loader('hide');
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Something went wrong with merging refer XML into Main XML.', error.message, error.stack, 'Error');
            });
    }

    getReferXMLbyId() {
        const self = this;
        loader('show');
        self.state.mainHub.invoke('getReferXMLbyId',
            self.state.eventID,
            self.state.simulationID
        )
            .then(function (response) {
                self.setState({
                    referXML: response
                }, () => {
                  const { events } = window;
                  
                  events.fire("loadFormServer", {
                    ...window.simITFormServerConfigs,
                    onSubmit: (logXml) => self.onFormSubmit(logXml),
                    graph: { data: response }
                  });
                });
                loader('hide');
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Something went wrong with getting refer XML.', error.message, error.stack);
            });
    }

    render() {
        return null;
    }
}